export default __webpack_public_path__ + "static/media/card1-edp.35453ce0.png";